import { Container, Modal, Typography } from "@mui/material";
import { Box } from "@mui/system";
import React, { useEffect, useState } from "react";
import boxStyles from "../../../styles/boxStyles";
import InformasiKejadian from "../Component/InformasiKejadian";
// import PotensiOutcome from './Component/PotensiOutcome';
import KemungkinanPenyebab from "../Component/KemungkinanPenyebab";
import EstimateImpact from "../Component/EstimateImpact";
import { v4 as uuidv4 } from "uuid";
import ApiService from "../../../services/ApiService";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import HeaderInvestigasi from "../../../components/IncidentManagement/Investigasi/K3Lainnya/HeaderInvestigasi";
import LanjutanInvestigasi from "../../../components/IncidentManagement/Investigasi/K3Lainnya/LanjutanInvestigasi";
import FooterInvestigasi from "../../../components/IncidentManagement/Investigasi/K3Lainnya/FooterInvestigasi";
import fieldStyles from "../../../styles/fieldStyles";
import HeaderTransportasi from "../../../components/IncidentManagement/Investigasi/Transportasi/HeaderTransportasi";
import DetailKlasifikasiKecelakaanTransportasi from "../../../components/IncidentManagement/Investigasi/Transportasi/DetailKlasifikasiKecelakaanTransportasi";
import AnalisaPenyebab from "../../../components/IncidentManagement/Investigasi/K3Lainnya/AnalisaPenyebab";
import LanjutanProcessSafety from "../../../components/IncidentManagement/Investigasi/ProcessSafety/LanjutanProcessSafety";

const LaporanProcessSafety = () => {
  const [showRecordable, setShowRecordable] = useState(0);
  const [inputFields, setInputFields] = useState({
    //// Header User
    idLkp: 0,
    noLkp: "",
    idUnitBisnis: 0,
    idRegional: 0,
    idLokasi: 0,
    tglKejadian: "",
    waktuKejadian: "",
    tglLaporan: new Date().toISOString().toString(),
    judulLaporan: "",
    //// Informasi Kejadian
    deskripsiSingkat: "",
    locationTagLong: 0,
    locationTagLat: 0,
    perusahaanTerlibat: "",
    // kurang jelas
    idKategoriHipo: 0,
    // kurang jelas
    listAllKategoriInsiden: [
      {
        idDetailLkpKategoriInsiden: 0,
        kategoriInsidenId: 0,
        kategoriInsidenName: "string",
        kategoriInsidenCode: "string",
        detailKategoriInsidenId: 0,
        detailKategoriInsidenName: "string",
        idKategoriHipo: 0,
        isCheked: true,
      },
    ],
    isReportAble: false,
    isWorkRelated: false,
    isRecordAble: false,
    //// Estimate Impact
    // kurang jelas
    listDetailEstimateImpact: [
      {
        detailEstimateImpactId: 0,
        kode: "string",
        nama: "string",
        isByValue: true,
      },
    ],
    // kurang jelas
    listDetailEstimateContent: [
      {
        idTblDataLkpEstimateImpact: 0,
        detailEstimateImpactId: 0,
        detailContentEstimateImpactId: 0,
        detailContentEstimateImpactName: "string",
        detailContentValueEstimateImpactId: 0,
        jumlahOrNilaiKerugian: 0,
        satuan: "string",
        tingkatKeparahan: 0,
        keterangan: "string",
        isByValue: true,
      },
    ],
    potensiTingkatKeparahan: "string",
    probabilitasKejadian: 0,
    //// Kemungkinan Penyebab
    kemungkinanPenyebabLangsung: "string",
    kemungkinanPenyebabDasar: "string",
    immadiateAction: "string",
    // Belum bisa diimplemetasi
    uploadDocumentList: [
      {
        id: 0,
        idLkp: 0,
        url: "string",
        isDelete: true,
      },
    ],
    pembuatDokumen: "string",
    createdBy: "string",
    modifiedBy: "string",
    saveAs: "string",

    //// Field di Estimate Impact
    // environment: [
    //   { id: uuidv4(), namaProduk: "", jumlah: "", satuan: "", keterangan: "" },
    // ],
    // financialImpact: [
    //   { id: uuidv4(), item: "", nilaiKerugian: "", satuan: "", keterangan: "" },
    // ],
    // reputationImpactLegal: [
    //   { id: uuidv4(), dampakReputasi: "", keterangan: "" },
    // ],
    // assetEquipment: [
    //   { id: uuidv4(), nilaiKerugian: "", satuan: "", keterangan: "" },
    // ],
    // publicNotification: [
    //   { id: uuidv4(), publicNotification: "", keterangan: "" },
    // ],
  });

  // Fetch Form LKP Initial Value
  const [initialValue, setInitialValue] = useState(null);
  const [listEIC, setListEIC] = useState(null);
  useEffect(() => {
    const fetchEIC = async () => {
      try {
        const v = await Promise.all(
          ApiService.getIncimanLkp(0).then((res) => {
            var result = res.data.payload;
            setInitialValue(result);

            var temp = [];
            result.listDetailEstimateImpact.forEach(async (dEI) => {
              await ApiService.getEstimateImpactContent(
                dEI.detailEstimateImpactId
              ).then((res2) => {
                var temp2 = [];

                res2.data.payload.forEach(async (dCEI) => {
                  await ApiService.getTingkatKeparahanByValue({
                    IdMstDetailEstimateImpact: dEI.detailEstimateImpactId,
                    ContectValue: dCEI.tingkatKeparahan,
                  }).then((res3) => {
                    temp2.push({
                      ...dCEI,
                      disabled: true,
                      listTingkatKeparahan: res3.data.payload,
                    });
                  });
                });

                temp.push({
                  ...dEI,
                  disabled: true,
                  content: temp2,
                });
              });
            });

            const delay = setInterval(() => {
              setListEIC(temp);
              clearInterval(delay);
            }, 3000);
          })
        );
      } catch (error) {}
    };

    fetchEIC();
  }, []);

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    console.log("media", media);

    try {
      const v = await ApiService.postUploadDocument("LKP", media).then(
        (upload) => {
          console.log(upload.data.payload);

          let finalValue = {
            ...inputFields,
            uploadDocumentList: upload.data.payload,
          };

          console.log("finalValue", finalValue);

          ApiService.postIncimanLkp({
            ...inputFields,
            uploadDocumentList: upload.data.payload,
          }).then((res) => {
            console.log("res.message", res.message);
          });
        }
      );
      console.log("v", v);
    } catch (error) {
      console.log("error", error);
    }

    handleOpen();
  };

  // File Upload
  const [media, setMedia] = useState(null);

  return (
    <div>
      <Container maxWidth={false}>
        <center>
          <h2>LAPORAN INVESTIGASI</h2>
        </center>
        <Box component="form" noValidate autoComplete="off">
          <HeaderTransportasi
            inputFields={inputFields}
            setInputFields={setInputFields}
          />
          <br></br>

          <InformasiKejadian
            setShowRecordable={setShowRecordable}
            inputFields={inputFields}
            setInputFields={setInputFields}
          />
          <br></br>

          {listEIC !== null && (
            <EstimateImpact
              showRecordable={showRecordable}
              inputFields={inputFields}
              setInputFields={setInputFields}
              title="Actual Impact"
              listEIC={listEIC}
            >
              <LanjutanProcessSafety
                fieldStyles={fieldStyles}
                setInputFields={setInputFields}
                inputFields={inputFields}
              />
            </EstimateImpact>
          )}
          <br></br>
          {/* <PotensiOutcome /> */}

          <AnalisaPenyebab
            inputFields={inputFields}
            setInputFields={setInputFields}
            media={media}
            setMedia={setMedia}
          />
        </Box>
        <br />
        <FooterInvestigasi handleSubmit={handleSubmit} />
      </Container>

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "552px",
            height: "552px",
            bgcolor: "#fff",
            boxShadow: "50px",
            borderRadius: "50px",
            textAlign: "center",
          }}
        >
          <CheckCircleIcon
            sx={{ fontSize: "207px", color: "#92D050", marginTop: "106px" }}
          />
          <div
            style={{ fontSize: "50px", color: "#797991", marginTop: "66px" }}
          >
            <b>SUCCESS</b>
          </div>
        </Box>
      </Modal>
    </div>
  );
};

export default LaporanProcessSafety;
